import React, { useState } from 'react';
import { Search, Plus, Loader2 } from 'lucide-react';
import NotificationsButton from '../NotificationsButton';
import { useAdminNotifications } from '../../hooks/useAdminNotifications';
import { useAuth } from '../../hooks/useAuth';

const DesktopHeader: React.FC = () => {
  const { createNotification } = useAdminNotifications();
  const { user } = useAuth();
  const [isCreating, setIsCreating] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => setIsModalOpen(false);

  const createTestNotification = async () => {
    if (isCreating) return;
    
    try {
      setIsCreating(true);
      console.log('Criando notificação de teste, user:', user);
      
      if (!user) {
        console.error('Usuário não autenticado');
        return;
      }

      const types = ['info', 'success', 'warning', 'error'] as const;
      const type = types[Math.floor(Math.random() * types.length)];
      
      const notification = {
        title: `Notificação de Teste (${type})`,
        message: 'Esta é uma notificação de teste para demonstrar o sistema.',
        type,
        link: '/admin/notifications'
      };

      console.log('Dados da notificação:', notification);
      const result = await createNotification(notification);
      console.log('Resultado da criação:', result);

      if (!result) {
        throw new Error('Falha ao criar notificação');
      }
    } catch (error) {
      console.error('Erro ao criar notificação:', error);
      alert('Erro ao criar notificação. Verifica a consola para mais detalhes.');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <>
      <div className="hidden md:block pt-20 relative z-50">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="mb-8 flex justify-between items-center">
            <div className="flex-1">
              <h1 className="text-2xl font-bold break-words">Painel de Administração</h1>
              <p className="text-gray-400 break-words">Gerencie todo o conteúdo do site num só lugar</p>
            </div>

            <div className="flex items-center gap-4 ml-4">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Pesquisar..."
                  className="w-64 pl-10 pr-4 py-2 bg-secondary rounded-full focus:ring-2 focus:ring-primary focus:outline-none"
                />
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              </div>

              <button
                onClick={createTestNotification}
                disabled={isCreating}
                className="p-2 hover:bg-secondary rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                title="Criar notificação de teste"
              >
                {isCreating ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <Plus className="w-5 h-5" />
                )}
              </button>

              <div className="relative z-30">
                <NotificationsButton onOpen={handleModalOpen} onClose={handleModalClose} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DesktopHeader;